import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-42fc687f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-page glass-panel"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("section", {
  class: "login-hero"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "hero-badge"
}, "Secure Sign-In"), /*#__PURE__*/_createElementVNode("h2", null, "登录口袋校园"), /*#__PURE__*/_createElementVNode("p", null, "使用校园账号或扫码，同步活动、通知与个人档案。"), /*#__PURE__*/_createElementVNode("ul", {
  class: "login-points"
}, [/*#__PURE__*/_createElementVNode("li", null, "活动报名与签到"), /*#__PURE__*/_createElementVNode("li", null, "通知与公告"), /*#__PURE__*/_createElementVNode("li", null, "二课学分档案")])], -1));
const _hoisted_3 = {
  class: "login-card"
};
const _hoisted_4 = {
  class: "login-mode-note"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "通道", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "login-school"
}, "学校", -1));
const _hoisted_7 = {
  key: 0,
  class: "school-tag"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "login-username"
}, "账号", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "login-password"
}, "密码", -1));
const _hoisted_10 = {
  class: "qr-code-container"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 1,
  class: "qr-placeholder"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "QR", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "选择学校后生成", -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("section", _hoisted_3, [_createElementVNode("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.login && $options.login(...args), ["prevent"])),
    class: "login-form"
  }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_hoisted_5, _createElementVNode("strong", null, _toDisplayString($options.apiModeOption.label), 1)]), _createElementVNode("button", {
    type: "button",
    class: "ghost-link",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goSettings && $options.goSettings(...args))
  }, "设置")]), _hoisted_6, _createVNode(_component_el_select, {
    id: "login-school",
    modelValue: $data.selectedSchool,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.selectedSchool = $event),
    filterable: "",
    placeholder: "搜索并选择学校",
    class: "custom-select",
    style: {
      width: '100%'
    },
    onChange: $options.handleSchoolChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.schoolList, school => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: school.email || school.go_id || school.id,
        label: school.name,
        value: school.email
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(school.name), 1), $options.schoolPlatformLabel(school) ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($options.schoolPlatformLabel(school)), 1)) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _hoisted_8, _createVNode(_component_el_input, {
    id: "login-username",
    modelValue: $data.username,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.username = $event),
    placeholder: "学号 / 用户名",
    required: "",
    autocomplete: "username"
  }, null, 8, ["modelValue"]), _hoisted_9, _createVNode(_component_el_input, {
    id: "login-password",
    modelValue: $data.password,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.password = $event),
    placeholder: "密码",
    type: "password",
    "show-password": "",
    required: "",
    autocomplete: "current-password"
  }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
    class: "login-submit",
    type: "primary",
    "native-type": "submit",
    loading: $data.loginLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.loginLoading ? '登录中…' : '登录'), 1)]),
    _: 1
  }, 8, ["loading"])], 32), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
    class: _normalizeClass(["qr-frame", {
      ready: Boolean($data.qrCodeUrl)
    }])
  }, [$data.qrCodeUrl ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $data.qrCodeUrl,
    alt: "扫码登录二维码"
  }, null, 8, _hoisted_11)) : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))], 2), _createElementVNode("p", null, _toDisplayString($data.qrCodeUrl ? "使用口袋校园 APP 扫码" : "选择学校后可扫码登录"), 1)])])]);
}